<template>
  <div class="column full-height">
    <header
      class="row items-center justify-between q-px-2x-md full-width"
      :style="{ height: '86px' }"
    >
      <span class="text-lg text-neutral text-weight-medium">
        {{ computedTitle }}
      </span>
      <PBtn
        color="primary"
        flat
        round
        :loading="editUserForm?.editCloseLoading"
        @click="onClose"
      >
        <CloseIcon class="icon" />
      </PBtn>
    </header>

    <q-separator color="neutral-40" />
    <AddUserForm v-if="!formState.edit" ref="add-user-form" />
    <EditUserForm v-else ref="edit-user-form" />
  </div>
</template>

<script setup>
import { useTemplateRef } from "vue";
import CloseIcon from "assets/icons/close.svg";

// Store references and reactive state
const { formState, user } = storeToRefs(useUserStore());

// Form references
const addUserForm = useTemplateRef("add-user-form");

const editUserForm = useTemplateRef("edit-user-form");

const { hash, removeQueryParams } = useRouterUtilities();

const hashRoleMap = {
  "#team-members": "team member",
  "#customers": "buyer",
  "#vendors": "seller",
};

const computedRole = computed(() => {
  return hashRoleMap[unref(hash)] || "user";
});

const isTeamMembers = ref(false);

//providers
provide("isTeamMembers", isTeamMembers);

provide("hashRole", computedRole);

// Role label mapping
const roleLabelMap = {
  seller: "Vendor",
  kam: "Kam",
  agent: "Agent",
  buyer: "Customer",
  "team member": "Team Member",
  user: "User",
};

// Computed title for the header
const computedTitle = computed(() => {
  const isEdit = formState.value.edit;

  const role = isEdit ? user.value.role : unref(computedRole) || "user";

  const roleLabel = roleLabelMap[role] || "User";

  return isEdit ? `${roleLabel} Details` : `Add ${roleLabel}`;
});

// Close button handler
const onClose = () => {
  if (formState.value.edit) {
    editUserForm.value?.editClose();
  } else {
    addUserForm.value?.addClose();
  }

  removeQueryParams();
};

// Update team members flag based on hash
const updateTeamMembersFlag = () => {
  isTeamMembers.value = unref(computedRole) === "team member" || false;
};

// Watch for form state changes to check the hash
watch(
  () => formState.value.open,
  (isOpen) => {
    if (isOpen) updateTeamMembersFlag();
  },
  { immediate: true },
);
</script>
